<template>
  <input-dropdown :options="mappedExtraProducts" :value="extraProductId" @change="handleInput"/>
</template>

<script>
import InputDropdown from "../../input/Dropdown";
import {mapGetters} from "vuex";

export default {
  name: 'ExtraProductsDropdown',

  components: {
    InputDropdown
  },

  computed: {
    ...mapGetters({
      extraProductId: "build/getExtraProductId",
      tank: "build/getTank",
    }),
    mappedExtraProducts() {
      const extraProducts = this.tank.extra_products;

      return extraProducts
          .sort((a, b) => a.pivot.sort_order - b.pivot.sort_order)
          .map((product) => {
            return {
              key: product.pivot.extra_product_id,
              value: product.name,
            }
          });
    },
  },

  methods: {
    handleInput(id) {
      this.$store.dispatch('build/setExtraProduct', id);
    }
  },

  watch: {
    tank: {
      handler() {
        if (this.mappedExtraProducts.length < 1) {
          this.$store.dispatch('build/setExtraProduct', null);
          return;
        }
        if (this.extraProductId === null) {
          this.$store.dispatch('build/setExtraProduct', this.mappedExtraProducts[0].key);
        }
      },
      deep: true,
      immediate: true,
    }
  },
}
</script>
